import {
  querySn,
  queryUser
} from '@/axios/logistics'

const logisticsData = {
  state: {
    snList: [],
    userInfo: {},
    userLoaded: false,
    curShare: {}
  },
  mutations: {
    SET_SN_LIST (state, data) {
      state.snList = data
    },
    SET_USER_INFO (state, data) {
      state.userInfo = data
    },
    SET_USER_LOADED (state, data) {
      state.userLoaded = data
    },
    SET_CUR_SHARE (state, data) {
      state.curShare = data
    }
  },
  actions: {
    setCurShare ({commit}, item) {
      commit('SET_CUR_SHARE', item)
    },
    async doQuerySnList ({commit}) {
      const res = await querySn()
      commit('SET_SN_LIST', res.data.data)
    },
    async doQueryUserInfo ({commit}) {
      try {
        const res = await queryUser()
        commit('SET_USER_LOADED', true)
        commit('SET_USER_INFO', res.data.data)
      } catch (error) {
        commit('SET_USER_LOADED', true)
        commit('SET_USER_INFO', {})
        // this.$message({
        //   type: 'error',
        //   message: (error.data && error.data.message) || '查询用户信息失败'
        // })
      }
    }
  }
}

export default logisticsData



// WEBPACK FOOTER //
// ./src/store/modules/logisticsData.js